import styled from 'styled-components';

const Header = styled.p`
  ${({ theme }) => theme.fontSize.L18}
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
`;

export { Header };
